export default {"src":"/_next/static/media/connect-to-apps.8dbb2057.svg","height":640,"width":747,"blurWidth":0,"blurHeight":0};